import React, { useEffect, useContext, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";

export default function PaymentSuccess() {
  const [params]                    = useSearchParams();
  const { cart, removeFromCart }    = useContext(CartContext);
  const orderId                     = params.get("order");
  const method                      = params.get("method");
  const clearedRef                  = useRef(false);

  // Clear cart once on mount — useRef prevents double-clear in StrictMode
  useEffect(() => {
    if (clearedRef.current) return;
    clearedRef.current = true;
    cart.forEach(item => removeFromCart(item._cartKey));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,400&family=DM+Sans:wght@300;400;500&display=swap');
        .ps-root*,.ps-root *::before,.ps-root *::after{box-sizing:border-box;margin:0;padding:0}
        .ps-root{font-family:'DM Sans',sans-serif;background:#fdf9f6;min-height:80vh;display:flex;align-items:center;justify-content:center;padding:40px 20px}
        .ps-card{background:#fff;border:1px solid #ede8e2;padding:52px 48px;max-width:520px;width:100%;text-align:center}
        @media(max-width:480px){.ps-card{padding:36px 24px}}
        .ps-icon{width:64px;height:64px;background:#fff5f8;border:2px solid #f5d0dc;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 24px}
        .ps-title{font-family:'Cormorant Garamond',serif;font-size:36px;font-weight:300;color:#1a1410;margin-bottom:10px;display:block}
        .ps-method{font-size:11px;color:#c87090;font-weight:500;margin-bottom:16px;display:block;letter-spacing:.1em;text-transform:uppercase}
        .ps-sub{font-size:14px;font-weight:300;color:#7a6e68;line-height:1.7;margin-bottom:28px;display:block}
        .ps-ref{background:#f7f4f1;padding:14px;margin-bottom:28px}
        .ps-ref-label{font-size:10px;font-weight:500;letter-spacing:.18em;text-transform:uppercase;color:#a09890;display:block;margin-bottom:4px}
        .ps-ref-val{font-size:13px;font-weight:500;color:#1a1410;display:block;word-break:break-all}
        .ps-actions{display:flex;gap:12px;justify-content:center;flex-wrap:wrap}
        .ps-btn{display:inline-block;padding:12px 24px;font-size:11px;font-weight:500;font-family:'DM Sans',sans-serif;letter-spacing:.18em;text-transform:uppercase;text-decoration:none;transition:all .2s}
        .ps-btn-primary{background:#1a1410;color:#fdf9f6}
        .ps-btn-primary:hover{background:#c87090}
        .ps-btn-outline{border:1.5px solid #ddd8d2;color:#5a524c}
        .ps-btn-outline:hover{border-color:#c87090;color:#c87090}
      `}</style>

      <div className="ps-root">
        <div className="ps-card">

          <div className="ps-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c87090" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>

          <span className="ps-title">Payment Successful!</span>

          {method && (
            <span className="ps-method">
              Paid via {method === "jazzcash" ? "JazzCash" : "Easypaisa"}
            </span>
          )}

          <span className="ps-sub">
            Thank you for your order. We'll start processing it right away
            and contact you on WhatsApp with delivery details.
          </span>

          {orderId && (
            <div className="ps-ref">
              <span className="ps-ref-label">Order Reference</span>
              <span className="ps-ref-val">{orderId}</span>
            </div>
          )}

          <div className="ps-actions">
            <Link to="/products" className="ps-btn ps-btn-primary">Continue Shopping</Link>
            <Link to="/track"    className="ps-btn ps-btn-outline">Track Order</Link>
          </div>

        </div>
      </div>
    </>
  );
}